import { useState } from "react";
import { Link } from "react-router-dom";
import gallery from "../../data/gallery";
import PlaceholderImage from "../common/PlaceholderImage";
import Lightbox from "../common/Lightbox";
import SectionHeading from "../common/SectionHeading";
import "./GalleryPreview.css";

const PREVIEW = gallery.slice(0, 8);

export default function GalleryPreview() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section className="gallery-preview section">
      <div className="container">
        <div className="gallery-preview__head">
          <SectionHeading eyebrow="Inside The Factory" title="A look" highlight="at the floor" />
          <Link to="/gallery" className="btn btn-outline">Full Gallery</Link>
        </div>
        <div className="gallery-preview__masonry">
          {PREVIEW.map((item, i) => (
            <button
              type="button"
              className="gallery-preview__item"
              key={item.id}
              onClick={() => setActiveIndex(i)}
              aria-label={`Open image: ${item.alt}`}
            >
              {/* <PlaceholderImage tone={item.tone} alt={item.alt} ratio={i % 3 === 0 ? "3/4" : "4/3"} /> */}
              <img src={item.img} />
            </button>
          ))}
        </div>
      </div>
      {activeIndex !== null && (
        <Lightbox
          items={PREVIEW}
          activeIndex={activeIndex}
          onClose={() => setActiveIndex(null)}
          onPrev={() => setActiveIndex((i) => (i - 1 + PREVIEW.length) % PREVIEW.length)}
          onNext={() => setActiveIndex((i) => (i + 1) % PREVIEW.length)}
        />
      )}
    </section>
  );
}
